import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';
import organizationResource from 'src/actions/organization/organizationResource';
import FormPage from 'src/presentation/components/pages/shared/FormPage';
import { STATUS_LOADING } from 'src/presentation/hooks/useResource';
import mobileNumberIdentificationConfigResource from 'src/actions/mobileNumberIdentification/mobileNumberIdentificationConfigResource';
import MobileNumberIdentificationForm from 'src/presentation/components/pages/mobileNumberIdentification/MobileNumberIdentificationForm';
import { RootState } from 'src/actions/configuration/rootReducer';

const MobileNumberIdentification: FC = () => {
  const { errors, loadingState, value } = useDocumentResource(mobileNumberIdentificationConfigResource);

  const orgId = useSelector((state: RootState) => state.auth.orgId);
  const { loadingState: organizationLoadingState } = useDocumentResource(organizationResource, {
    fetch: true,
    params: { orgId },
  });

  const description = (
    <div>
      Automatically recognize customers by their mobile phone number, so agents immediately know who’s calling. You can
      learn more about Mobile Phone Number Identification in our{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://help.gladly.com/docs/activate-mobile-phone-number-identification"
      >
        Help Docs
      </a>
      .
    </div>
  );

  return (
    <FormPage
      isLoading={loadingState === STATUS_LOADING || organizationLoadingState === STATUS_LOADING}
      form={MobileNumberIdentificationForm}
      title="Mobile Phone Number Identification"
      description={description}
      errors={errors}
      item={value}
      fillHeight={true}
      resetErrors={mobileNumberIdentificationConfigResource.actions.resetErrors}
      data-aid="admin-mobile-number-identification-page"
    />
  );
};

export default MobileNumberIdentification;
